import { NewAllowanceForm } from "./_components/new-allowance-form";

const CreateAllowancePage = () => {
  return (
    <div className="p-2 md:h-[calc(100%-56px)] h-[calc(100vh-56px)]">
      <div className="h-full rounded-md">
        <NewAllowanceForm />
      </div>
    </div>
  );
};

export default CreateAllowancePage;
